import {
  BrowserRouter,
  Route,
  Routes as BrowserRoutes,
} from "react-router-dom";
import Colaboradores from "../pages/Colaboradores";
import Defeitos from "../pages/Defeitos";
import HistoricoParada from "../pages/HistoricoParada";
import Login from "../pages/Login";
import TipoParada from "../pages/TipoParada";
import Turmas from "../pages/Turmas";
import LancamentoParada from "../pages/LancamentoParada";
import Paradas from "../pages/Paradas";
import HistoricoDefeitos from "../pages/HistoricoDefeitos";
import HistoricoDefeitosRelatorio from "../pages/HistoricoDefeitosRelatorio";
import HistoricoDefeitosRoloRelatorio from "../pages/HistoricoDefeitosRoloRelatorio";
import Relatorios from "../pages/Relatorios";
import Eficiencia from "../pages/Eficiencia";
import RelatorioDefeitos from "../pages/RelatorioDefeitos";
import Configuracao from "../pages/Configuracao";
import Home from "../pages/Home";
import Importacoes from "../pages/Importacoes";
import NotFound from "../pages/NotFound";
import ImportacoesDados from "../pages/ImportacoesDados";
import { ReportProvider } from "../context/report";
import { ManutencaoRelatorio } from "../pages/Manutencao/Relatorio";
import { Sala } from "../pages/Sala";
import { Geral } from "../pages/Producao/Geral";
import { CadastroQualidade } from "../pages/Qualidade/CadastroQualidade";
import { Premio } from "../pages/Qualidade/Premio";
import { MetragemPeriodo } from "../pages/Cadastros/MetragemPeriodo";
import { ArtigoTempo } from "../pages/Producao/ArtigoTempo";

import AdminRoutes from "./AdminRoutes";
import RevisaoRoutes from "./RevisaoRoutes";
import SignedRoutes from "./SignedRoutes";
import SupervisaoRoutes from "./SupervisorRoutes";
import ManutencaoTipos from "../pages/Manutencao/Tipos";
import { ArtigoPCP } from "../pages/Producao/ArtigoPCP";
import Solicitacoes from "../pages/Estoque/Solicitacoes";
import PremioEficiencia from "../pages/Cadastros/PremioEficiencia";
import EficienciaTeares from "../pages/Outros/EficienciaTeares";
import Layout from "../pages/Outros/Layout";
import MapaRolada from "../pages/Outros/MapaRolada";
import AcabamentoRoutes from "./AcabamentoRoutes";
import Revisao from "../pages/Outros/Revisao";
import EstoqueProdutos from "../pages/Manutencao/EstoqueProdutos";
import Produtos from "../pages/Manutencao/Produtos";
import EstoqueFiacao from "../pages/Estoque/Fiacao";
import DashboardSanforizadeira from "../pages/Sanforizadeira/Dashboard";
import Gas from "../pages/Sanforizadeira/Lancamentos/Gas";
import GasHistorico from "../pages/Sanforizadeira/Historicos/GasHistorico";
import AcabamentoParadas from "../pages/Sanforizadeira/Paradas";
import ParadaHistorico from "../pages/Sanforizadeira/Historicos/Parada";
import AcabamentoRelatorio from "../pages/Sanforizadeira/Relatorio";
import AcabamentoTemperatura from "../pages/Sanforizadeira/Lancamentos/Temperatura";
import AcabamentoLancamentoParadaV2 from "../pages/Sanforizadeira/Lancamentos/ParadaV2";
import AcabamentoParametro from "../pages/Sanforizadeira/Lancamentos/Parametro";
import HistoricoTemperatura from "../pages/Sanforizadeira/Historicos/Temperatura";
import AcabamentoTemperaturaConfiguracao from "../pages/Sanforizadeira/Lancamentos/TemperaturaConfiguracao";
import CortesOperador from "../pages/Operadores/Cortes";
import { Ocorrencias } from "../pages/Outros/Ocorrencias";
import TecelagemRoutes from "./TecelagemRoutes";
import { ControleTurma } from "../pages/Outros/ControleTurma";
import DashboardRoutes from "./DashboardRoutes";
import BalanceamentoProducao from "../pages/Outros/BalanceamentoProducao";
import { MetaDiaria } from "../pages/Outros/MetaDiaria";
import { PCPRestricao } from "../pages/Outros/PCPRestricao";
import { FiacaoTempoReal } from "../pages/Outros/FiacaoTempoReal";
import { CadastroResiduo } from "../pages/Cadastros/Residuos";
import MetasTextil from "../pages/Metas";
import HistoricoDefeitosGraf from "../pages/HistoricoDefeitosGraf";
import {Defeito} from "../pages/Qualidade/Defeito";
import RelatorioDefeitosDiario from "../pages/RelatorioDefeitosDiario";
import RelatorioDefeitosMetragem from "../pages/RelatorioDefeitosMetragem";
import RelatorioManutencao from "../pages/RelatorioManutenção";
import TesteQuebrasTrama from "../pages/TesteXML";
import TabelaIndiceVendaCorte from "../components/Tabelas/IndiceVendaCorte";
import ControleEstoqueFio from "../pages/Estoque/ControleEstoqueFio";
import FioMapeamento from "../pages/Cadastros/FioMapeamento";
import ProgramacaoRolo from "../pages/Programacao";
import MetaProducao from "../pages/Utilidades/MetaProducao";
import RelatorioProjecaoProducao from "../pages/Utilidades/RelatorioProjecaoProducao";
import { EficienciaTelevisao } from "../pages/Utilidades/EficienciaTelevisao";
import RelatorioQualidadeDiario from "../pages/RelatorioQualidadeDiario";
import RelatorioQualidadeOperador from "../pages/RelatorioQualidadeOperador";
import ControleQualidade from "../pages/ControleQualidade";
import { EntradasSaidas } from "../pages/Outros/EntradasSaidasTecido";

export default function Routes() {
  return (
    <BrowserRouter>
      <BrowserRoutes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<NotFound />} />
        <Route path="eficiencia-televisao" element={<EficienciaTelevisao />} />
        
        <Route element={<SignedRoutes />}>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/" element={<AdminRoutes />}>
            <Route path="importacoes" element={<Importacoes />} />
            <Route path="teste-quebras-trama" element={<TesteQuebrasTrama />} />
            <Route
              path="importacoes/dados/:importId"
              element={<ImportacoesDados />}
            />
            <Route path="paradas/lancamento" element={<LancamentoParada />} />
            <Route path="paradas/historico" element={<HistoricoParada />} />

            <Route path="mapa-rolada" element={<MapaRolada />} />

            <Route path="eficiencia/:importId" element={<Eficiencia />} />
            <Route path="cadastros">
              <Route path="artigos-pcp" element={<ArtigoPCP />} />
              <Route path="colaboradores" element={<Colaboradores />} />
              <Route path="fio-mapeamento" element={<FioMapeamento />} />
              <Route path="metragem-periodo" element={<MetragemPeriodo />} />
              <Route path="artigo-tempo" element={<ArtigoTempo />} />
              <Route path="turmas" element={<Turmas />} />
              <Route path="paradas" element={<Paradas />} />
              <Route path="residuos" element={<CadastroResiduo />} />
              <Route path="tipos-parada" element={<TipoParada />} />
              <Route path="premio-eficiencia" element={<PremioEficiencia />} />
              <Route path="metas-textil" element={<MetasTextil />} />
            </Route>

            <Route path="controle-turma" element={<ControleTurma />} />
            <Route path="indice-venda-corte" element={<TabelaIndiceVendaCorte />} />
            <Route path="pcp-restricao" element={<PCPRestricao />} />
            <Route path="fiacao-tempo-real" element={<FiacaoTempoReal />} />
            <Route path="entradas-saidas" element={<EntradasSaidas />} />

            {/* Qualidade */}
            <Route path="/" element={<SupervisaoRoutes />}>
              <Route
                path="cadastros/qualidade"
                element={<CadastroQualidade />}
              />
              <Route path="defeitos/premio" element={<Premio />} />
              <Route path="defeitos/premio/defeitos_turma" element={<Defeito />} />
            </Route>
          </Route>

          <Route path="/" element={<AcabamentoRoutes />}>
            <Route path="programacao" element={<ProgramacaoRolo />} />
            <Route path="acabamento">
              <Route path="cadastro">
                <Route path="paradas" element={<AcabamentoParadas />} />
                <Route path="parametros" element={<AcabamentoParametro />} />
                <Route
                  path="temperatura-configuracao"
                  element={<AcabamentoTemperaturaConfiguracao />}
                />
              </Route>

              <Route path="dashboard" element={<DashboardSanforizadeira />} />
              <Route path="estoque-fiacao" element={<EstoqueFiacao />} />
              <Route path="relatorio" element={<AcabamentoRelatorio />} />

              <Route path="gas" element={<Gas />} />
              <Route path="gas-historico" element={<GasHistorico />} />

              <Route
                path="paradas"
                element={<AcabamentoLancamentoParadaV2 />}
              />
              <Route path="paradas-historico" element={<ParadaHistorico />} />

              <Route
                path="temperatura/:id"
                element={<AcabamentoTemperatura />}
              />
              <Route
                path="temperatura-historico"
                element={<HistoricoTemperatura />}
              />
            </Route>
          </Route>

          <Route
            path="balanceamento-producao"
            element={
              <ReportProvider>
                <BalanceamentoProducao />
              </ReportProvider>
            }
          />

          <Route path="produtos" element={<Produtos />} />
          <Route path="eficiencia-teares" element={<EficienciaTeares />} />
          <Route path="cortes" element={<CortesOperador />} />
          <Route path="meta-diaria" element={<MetaDiaria />} />
          <Route path="meta-producao" element={<MetaProducao />} />
          <Route path="relatorio-projecao-producao" element={<RelatorioProjecaoProducao />} />

          {/* Manutenção */}
          <Route path="manutencao">
            <Route path="relatorios" element={<ManutencaoRelatorio />} />
            <Route path="tipos" element={<ManutencaoTipos />} />
          </Route>

          <Route path="estoque">
            <Route path="fiacao" element={<EstoqueFiacao />} />
            <Route path="produtos" element={<EstoqueProdutos />} />
            <Route path="fio" element={<ControleEstoqueFio />} />
            <Route path="solicitacoes" element={<Solicitacoes />} />
          </Route>

          <Route path="/" element={<TecelagemRoutes />}>
            <Route path="ocorrencias" element={<Ocorrencias />} />
          </Route>

          <Route path="configuracao" element={<Configuracao />} />
          <Route path="layout" element={<Layout />} />
          <Route path="maquinas" element={<Sala />} />
          <Route path="manutencao/relatorio" element={ < RelatorioManutencao/> } />
          <Route path="revisao" element={<Revisao />} />
          <Route
            path="relatorios"
            element={
              <ReportProvider>
                <Relatorios />
              </ReportProvider>
            }
          />

          <Route
            path="producao-geral"
            element={
              <ReportProvider>
                <Geral />
              </ReportProvider>
            }
          />

          <Route
            path="defeitos/relatorio"
            element={
              <ReportProvider>
                <RelatorioDefeitos />
              </ReportProvider>
            }
          />

          <Route
            path="defeitos/relatorio-diario"
            element={
              <ReportProvider>
                <RelatorioDefeitosDiario />
              </ReportProvider>
            }
          />

          <Route
            path="defeitos/relatorio-diario-qualidade"
            element={
              <ReportProvider>
                <RelatorioQualidadeDiario />
              </ReportProvider>
            }
          />

          <Route
            path="defeitos/relatorio-metragem"
            element={
              <ReportProvider>
                <RelatorioDefeitosMetragem />
              </ReportProvider>
            }
          />

          <Route
            path="defeitos/relatorio-qualidade-operador"
            element={<RelatorioQualidadeOperador />}
          />

          <Route
            path="defeitos/controle-qualidade"
            element={<ControleQualidade />}
          />

          <Route path="" element={<DashboardRoutes />}>
            <Route path="revisao" element={<Revisao />} />
          </Route>

          <Route path="/" element={<RevisaoRoutes />}>
            <Route path="cadastros/defeitos" element={<Defeitos />} />
            <Route path="defeitos/historico" element={<HistoricoDefeitos />} />
            <Route path="defeitos/historico/relatorio" element={<HistoricoDefeitosRelatorio />} />
            <Route path="defeitos/historico/relatoriorolo" element={<HistoricoDefeitosRoloRelatorio />} />
            <Route path="defeitos/historico-graficos" element={<HistoricoDefeitosGraf />} />
          </Route>
        </Route>
      </BrowserRoutes>
    </BrowserRouter>
  );
}
